import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface GraphAgentTabsUpdatedEvent {
  thingieId: string;
  selectedGraphConfigUuid?: string;
}

@Injectable({ providedIn: 'root' })
export class GraphAgentEventsService {
  private readonly graphTabsUpdatedSubject = new Subject<GraphAgentTabsUpdatedEvent>();

  public readonly graphTabsUpdated$ = this.graphTabsUpdatedSubject.asObservable();

  public notifyGraphTabsUpdated(event: GraphAgentTabsUpdatedEvent): void {
    this.graphTabsUpdatedSubject.next(event);
  }
}
